var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BonusesPrint',{attrs:{"info":_vm.info,"signatureInfo":_vm.signatureInfo,"correlatorDate":_vm.correlatorDate,"fullName":_vm.fullName}})
}
var staticRenderFns = []

export { render, staticRenderFns }